export const OPACITY_DEFAULT = 100;